import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Hero from './sections/Hero';
import Features from './sections/Features';
import AiSection from './sections/AiSection';
import TrackingSection from './sections/TrackingSection';
import DownloadSection from './sections/DownloadSection';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Layout from './Layout';
import ScrollToTop from './components/ScrollToTop';
import ContactUs from './pages/ContactUs';

function App() {
  useEffect(() => {
    // AOS (Animate On Scroll) kütüphanesini başlat
    AOS.init({
      duration: 1000,
      once: false,
    });

    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route
            index
            element={
              <>
                <Hero />
                <Features />
                <AiSection />
                <TrackingSection />
                <DownloadSection />
              </>
            }
          />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="tos" element={<TermsOfService />} />
          <Route path="contactus" element={<ContactUs />} />
        </Route>
      </Routes>
    </Router>
  );


}

export default App; 